import { useCallback, useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig";

const useUserApps = (user) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchUserApps = useCallback(async () => {
        if (!user?.uid) return;

        try {
            const appsRef = collection(db, "apps");
            const q = query(appsRef, where("ownerId", "==", user.uid));

            const snapshot = await getDocs(q);
            const apps = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));

            setData(apps);
        } catch (err) {
            console.error("Error fetching apps:", err);
        } finally {
            setLoading(false);
        }
    }, [user?.uid]);

    useEffect(() => {
        fetchUserApps();
    }, [fetchUserApps]);

    return { data, loading, refetchApplications: fetchUserApps };
};

export default useUserApps;
